import React, { useState } from "react";

import { Modal } from "shared/components/Modal";
import useModal from "shared/hooks/useModal";

type VeroGoModalContext = {
  title: string;
  metaLabel?: string;
  metaValue?: string;
  bodyText: React.ReactNode;
  submitButtonLabel?: string;
  cancelLinkLabel?: string;
  confirmValue?: string;
  cancelValue?: string;
  onConfirm?: () => Promise<void> | void;
};

const VeroGoSettingsModal = () => {
  const [submitting, setSubmitting] = useState(false);
  const { currentModalContext, selfApi } = useModal();
  const {
    title,
    metaLabel,
    metaValue,
    bodyText,
    submitButtonLabel = "Confirm",
    cancelLinkLabel = "Cancel",
    confirmValue = "confirm",
    cancelValue = "cancel",
    onConfirm,
  } = currentModalContext as VeroGoModalContext;

  return (
    <Modal
      title={title}
      centered
      showSubmitButton
      submitButtonLabel={submitButtonLabel}
      submit={async () => {
        try {
          setSubmitting(true);
          if (onConfirm) await onConfirm();
        } finally {
          setSubmitting(false);
        }
        selfApi.setClosingValue(confirmValue);
      }}
      submitting={submitting}
      showCancelLink
      cancelLinkLabel={cancelLinkLabel}
      onCancelLinkClick={() => {
        selfApi.setClosingValue(cancelValue);
        selfApi.closeDialog();
      }}
    >
      <Modal.Body style={{ paddingTop: 16 }}>
        {metaLabel && metaValue && (
          <p style={{ margin: "0 0 8px", fontWeight: 500 }}>
            {metaLabel}: {metaValue}
          </p>
        )}
        <p style={{ margin: 0 }}>{bodyText}</p>
      </Modal.Body>
    </Modal>
  );
};

export default VeroGoSettingsModal;
